import React from 'react'

function AdminView() {
    return (
        <div><h1>This is admin</h1></div>
    )
}

export default AdminView;